module.exports = __webpack_public_path__ + "media/images/covers/foundation/University-of-Southampton-logo-bd2308a900089090291838eda822432a.svg";